import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import JSApp from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<JSApp/>);
